import { useState, useEffect } from 'react'
import { Button } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import Logo from 'components/Navigation/MCLogo/assets/logo.svg'

export const NotFoundPage = () => {
  const { t } = useTranslation('@mc/next')
  const stories = t('notFoundPage.stories', { returnObjects: true }) as string[]
  const [story, setStory] = useState<string | null>(null)

  useEffect(() => {
    setStory(stories[Math.floor(Math.random() * stories.length)])
  }, [stories])

  return (
    <div className='mc-my-3 mc-my-md-12'>
      <div className='container'>
        <div className='row justify-content-center'>
          <div className='col-12 col-md-8 col-lg-6 mc-text--center'>
            <a href={paths.root} className='d-inline-block mc-mb-4'>
              <Logo
                className='mc-icon mc-text-color--primary'
                style={{ width: 120, height: 120 }}
              />
            </a>
            <h1 className='mc-text-h2 mc-mb-6'>{t('notFoundPage.heading')}</h1>
            <p className='mc-opacity--muted mc-mb-3'>
              {t('notFoundPage.didYouKnow')}
            </p>
            <p className='mc-opacity--muted mc-text--balance mc-mb-6'>
              {story}
            </p>
            <p className='mc-mb-6'>{t('notFoundPage.goBack')}</p>
            <Button
              render={<a href={paths.root} />}
              kind='secondary'
              size='md'
              style={{ textTransform: 'none' }}
            >
              {t('notFoundPage.cta')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
